import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M1.5 9.249A7.75 7.75 0 0 1 9.25 1.5a7.749 7.749 0 1 1 0 15.496A7.75 7.75 0 0 1 1.5 9.249M9.25 0C4.142.001 0 4.141 0 9.249s4.142 9.248 9.25 9.248a9.2 9.2 0 0 0 5.988-2.198l3.48 3.481a.75.75 0 1 0 1.061-1.06l-3.48-3.482a9.2 9.2 0 0 0 2.201-5.99C18.5 4.142 14.36.002 9.25.002",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }